import ModalCompressor from './ModalCompressor';

export default ModalCompressor;
